// src/utils/storeUtils.js
/**
 * Store ID to name mapping
 */
export const STORE_NAMES = {
  1: 'PH Head Office',
  101: 'Glorietta',
  102: 'Alabang',
  103: 'Trinoma',
  104: 'Manila Bay',
  105: 'Feliz',
  106: 'Gateway',
  107: 'Festival',
  108: 'Nuvali',
  109: 'Evo City'
}

/**
 * Get store options for dropdown selects
 */
export const getStoreOptions = () => {
  return Object.entries(STORE_NAMES).map(([id, name]) => ({
    value: id,
    label: name
  }))
}

/**
 * Function to get store name from store ID
 * @param {number|string} storeId - The store ID to get name for
 * @returns {string|null} Store name or null if not found
 */
export const getStoreNameById = (storeId) => {
  if (!storeId) return null
  return STORE_NAMES[parseInt(storeId)] || null
}

/**
 * Function to get store name from username (for Cognito users)
 * @param {string} username - The username to extract store code from
 * @returns {string|null} Store name or null if not found
 */
export const getStoreName = (username) => {
  if (!username) return null
  const storeCode = parseInt(username.replace(/\D/g, ' ').trim().split(' ')[0])
  return STORE_NAMES[storeCode] || null
}

/**
 * Function to get store code from store name
 * @param {string} storeName - The store name to find code for
 * @returns {string|null} Store code or null if not found
 */
export const getStoreCode = (storeName) => {
  const entries = Object.entries(STORE_NAMES)
  const found = entries.find(([, name]) => name === storeName)
  return found ? found[0] : null
}

/**
 * Check if user belongs to a specific store
 * @param {string} username - The username to check
 * @param {string} storeName - The store name to check against
 * @returns {boolean} True if user belongs to the store
 */
export const isUserFromStore = (username, storeName) => {
  const userStoreName = getStoreName(username)
  return userStoreName === storeName
}

/**
 * Determine user role based on permissions
 * @param {Object} permissions - User permissions object
 * @returns {string} User role
 */
export const getUserRole = (permissions) => {
  if (!permissions) return 'User'

  if (permissions.closeMonth) {
    return 'Operation Manager'
  } else if (permissions.pettyCashWrite) {
    return 'Store Manager'
  }

  return 'User'
}